<template>
	<div>
		<b-img src="/images/importer/module-touch-targets/touch-targets.jpg"></b-img>
		<p>
			The Touch Targets module is for setting up markers on your character that the character's hands (or their partner's) will be attached to during certain animations and activities.
		</p>
        
		<p>
			<span class="font-weight-bold">Generate Touch Targets:</span> Click this to generate the touch targets on your character, which are attached as children to the appropriate body parts.
			The touch targets are oriented at approximately the right position/orientation but may need to be adjusted depending on the proportion of your character, or the angle of their limbs
			when in the T-pose. See the Example scenes for reference in orienting the touch targets correctly.
		</p>
        
		<p>
			<span class="font-weight-bold">Touch Targets:</span> These list the touch targets on the character and their body parts. Items should not be manually added
			to these lists - just use the Generate button to create the necessary targets. You can, however, use these lists to easily find the touch target objects in your character's hierarchy - 
			click on one of the touch targets to highlight it in the Hierarchy window, then click on the touch target object itself for Help Wording instructions on how that touch target should 
			be placed on your character's body.
		</p>
	</div>
</template>

<script>
export default {
		name: 'TouchTargetsModule',
}
</script>
